export default __webpack_public_path__ + "static/media/ms-icon-70x70.a0be9694.png";